import * as React from "react";
import { Box, Text, Button, useLocalVariant } from "@draftkings/arena-web";
export const CashOutViewConfirmChanges = React.memo(function CashOutViewConfirmChanges(props) {
    const { formattedCashOutAmount, purchaseId, message, onClick } = props;
    const buttonVariant = useLocalVariant("button", {
        $extendFromVariant: "primaryMedium",
        root: {
            marginBottom: "$s2",
            cursor: "pointer",
        }
    });
    return React.createElement(Box, { width: "100%" },
        React.createElement(Text, { testId: `cashout-message-${purchaseId}`, variant: "notification" }, message),
        React.createElement(Button, { onClick: onClick, widthMode: "stretch", variant: buttonVariant, testId: `cashout-button-${purchaseId}` }, formattedCashOutAmount));
});
//# sourceMappingURL=CashOutViewConfirmChanges.js.map